"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
function setRef(ref, value) {
    if (typeof ref === 'function') {
        ref(value);
    }
    else if (ref) {
        ref.current = value;
    }
}
exports.setRef = setRef;
function createForkRef() {
    var refs = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        refs[_i] = arguments[_i];
    }
    if (!refs.length) {
        return null;
    }
    return function (refValue) {
        refs.forEach(function (r) {
            setRef(r, refValue);
        });
    };
}
exports.createForkRef = createForkRef;
function withForwardedRef(Component) {
    if (!Component) {
        return null;
    }
    return react_1.default.forwardRef(function (props, ref) {
        return react_1.default.createElement(Component, __assign({}, props, { forwardedRef: ref }));
    });
}
exports.withForwardedRef = withForwardedRef;
//# sourceMappingURL=reactHelpers.js.map